import React, { useMemo } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';
import { Button, Tooltip, Link } from '../../../../ui';
import { withStyles } from '@material-ui/core';

const LinkButton = withStyles(
  theme => ({
    root: {
      '& .MuiButton-label': {
        textDecoration: 'underline',
        fontWeight: theme.typography.fontWeightBold
      }
    }
  }),
  { name: 'FdButtonLink' }
)(Button);

export type VoucherEditLinkProps = {
  dataFd: string;
  disabled?: boolean;
  vrId: number | string;
  type: 'collection' | 'delivery';
  id: number | string;
  paymentAccountId: number;
  concessionStoreId?: number | string;
  edit?: boolean;
  onClick?(): void;
  tooltip?: string;
};
const VoucherEditLink: React.FC<VoucherEditLinkProps> = props => {
  const {
    dataFd,
    vrId,
    type,
    id,
    paymentAccountId: paId = 0,
    concessionStoreId: csId,
    edit,
    disabled,
    onClick,
    children,
    tooltip = ''
  } = props;

  const renderLink = useMemo(
    () =>
      React.forwardRef<
        HTMLAnchorElement,
        Omit<RouterLinkProps, 'innerRef' | 'to'>
      >((linkProps, ref) => {
        const toAppend = csId ? `/${csId}` : '';
        const to = `/voucher/${vrId}/${type}/${id}/${paId}${toAppend}?action=${
          edit ? 'change' : 'add'
        }`;
        return (
          <RouterLink
            to={to}
            onClick={onClick}
            disabled={disabled}
            {...linkProps}
            ref={ref as any}
          />
        );
      }),
    [vrId, type, id, paId, csId]
  );

  return (
    <Tooltip title={tooltip}>
      <span>
        <LinkButton
          data-fd={dataFd}
          component={renderLink}
          variant="text"
          color="default"
          disabled={disabled}
        >
          {children}
        </LinkButton>
      </span>
    </Tooltip>
  );
};

export default VoucherEditLink;
